module.exports = __webpack_public_path__ + "img/3,w_600.f1953bcd.jpg";